import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import {
  AgreeEvaluationMutationDocument,
  GetEvaluationAgreementsDocument,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  evaluationId: number
  onClose: () => void
}

const AgreeEvaluationModal = ({ evaluationId, onClose }: Props) => {
  const { access } = useCurrentSession()
  const [createAgreement] = useMutation(AgreeEvaluationMutationDocument, {
    extractorFn: (data) =>
      data.performanceReviewsMutations.agreePerformancereviewsEvaluationAgreement,
  })

  const { running, performAction: onSubmit } = useAsyncAction(async () => {
    const response = await createAgreement({
      awaitRefetchQueries: true,
      variables: {
        authorId: access.id,
        evaluationId: evaluationId,
      },
      refetchQueries: [
        {
          query: GetEvaluationAgreementsDocument,
          variables: {
            evaluation_id: evaluationId,
          },
        },
      ],
    })
    const handled = handleResult(response, () => {
      // TODO: do something with form errors
    })
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    }
    onClose()
    return handled
  })

  return (
    <Modal
      illustration="alert"
      title={i18n.t('surveys.review.reviews.agreements_section.modal.title.agreement')}
      description={i18n.t('surveys.review.reviews.agreements_section.modal.description.agreement')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={() => onClose()}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('common.continue')}
          </Button>
        </>
      }
    />
  )
}

export default observer(AgreeEvaluationModal)
